export default __webpack_public_path__ + "static/media/plus-square-solid.5a1fad5a.png";